import { http } from 'http';

export default {
  deleteDocument: ({ container, folder, fileName }) =>
    http.delete(`/3p/docs/${container}/${folder}/${fileName}`)
};
